import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../../../redux/actions/ApplicationAction";
import notify from "../../../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Banqi = () => {
  const [emptype, setemptype] = useState("");
  const [salary, setsalary] = useState("");
  const [anyloans, setanyloans] = useState("");
  const [anyloansP, setanyloansP] = useState("");

  const [Nationalid, setNationalid] = useState("");
  const [GuaraID, setGuaraID] = useState("");
  const [salarystate, setsalarystate] = useState("");
  const [empstate, setempstate] = useState("");
  const [facilitiesRec, setfacilitiesRec] = useState("");
  // const [carcontract,setcarcontract]=useState("")
  const [Others, setOthers] = useState([]);
  const [ageP, setageP] = useState("");
  const [salaryP, setsalaryP] = useState("");
  const dispatch = useDispatch();
  const [TypeofUse, setTypeofUse] = useState("");
  const navegate = useNavigate();
  const [NationalidP, setNationalidP] = useState("");
  const [GuaraIDP, setGuaraIDP] = useState("");
  const [TaminP, setTaminP] = useState("");
  const [facilitiesRecP, setfacilitiesRecP] = useState("");
  // const [carcontractP,setcarcontractP]=useState("")
  const idcar = localStorage.getItem("id_car");
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const [inputsEmp, setInputsEmp] = useState([""]);
  const [salarystateFile, setsalarystateFile] = useState("");
  const [inputsP, setInputsP] = useState([""]);
  const handleInputChange =(index, event) => {

    const newInputs = [...inputsEmp];
    newInputs[index] = event.target.value;  
    setInputsEmp(newInputs);
  };
  const handleFileChangeOthers = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handleAddInput = (e) => {
    if(inputsEmp.includes("")){
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setInputsEmp([...inputsEmp, ""]);
  };

  const handleRemoveInput = (index) => {
    const newInputs = [...inputsEmp];
    newInputs.splice(index, 1);
    setInputsEmp(newInputs);
  };
  const handleInputChangeP = (index, event) => {
    const newInputs = [...inputsP];
    newInputs[index] = event.target.value;
    setInputsP(newInputs);
  };

  const handleAddInputP = () => {
    if(inputsP.includes("")){
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setInputsP([...inputsP, ""]);
  };

  const handleRemoveInputP = (index) => {
    const newInputs = [...inputsP];
    newInputs.splice(index, 1);
    setInputsP(newInputs);
  };
  const handlesubmitEmp = async (e) => {
    e.preventDefault();
    if (
      Nationalid === "" ||
      GuaraID === "" ||
      empstate === "" ||
      facilitiesRec === "" ||
      salarystate === "" ||
      salary === "" ||
      anyloans === ""||
      emptype===""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 1);
    formData.append("car_id", idcar);
    formData.append("comment", "want to pay using bank");
    formData.append("payment_type", "bank");
    formData.append("client_national_id", Nationalid);
    formData.append("guarantor_national_id", GuaraID);
    Others.map((item) => {
      return formData.append("others", item);
    });
    formData.append("employee_statement", empstate);
    formData.append("facilities_receipt", facilitiesRec);
    formData.append("salary_statement", salarystate);
    formData.append(
      "car_loan",
      JSON.stringify({
        loan_type: "employee",
        salary: salary,
      })
    );
    formData.append("loans", inputsEmp.join(","));
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setemptype("");
    setsalary("");
    setanyloans("");
    setanyloansP("");
    setNationalid("");
    setGuaraID("");
    setsalarystate("");
    setempstate("");
    setfacilitiesRec("");
    setOthers("");
    setageP("");
    setsalaryP("");
    setTypeofUse("");
    setNationalidP("");
    setGuaraIDP("");
    setTaminP("");
    setfacilitiesRecP("");
  };
  const handlesubmitP = async (e) => {
    e.preventDefault();
    if (
      NationalidP === "" ||
      GuaraIDP === "" ||
      TaminP === "" ||
      facilitiesRecP === "" ||
      TypeofUse === "" ||
      salaryP === "" ||
      ageP === "" ||
      anyloansP === "" ||
      emptype === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 1);
    formData.append("car_id", idcar);
    formData.append("comment", "want to pay using bank");
    formData.append("payment_type", "bank");
    formData.append("client_national_id", NationalidP);
    formData.append("guarantor_national_id", GuaraIDP);
    formData.append("insurance", TaminP);
    formData.append("facilities_receipt", facilitiesRecP);

    formData.append(
      "car_loan",
      JSON.stringify({
        loan_type: "pensioner",
        salary: salaryP,
        type_of_use: TypeofUse,
        client_age: ageP,
      })
    );
    formData.append("loans", inputsP.join(","));

    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setemptype("");
    setsalary("");
    setanyloans("");
    setanyloansP("");
    setNationalid("");
    setGuaraID("");
    setsalarystate("");
    setempstate("");
    setfacilitiesRec("");
    setOthers("");
    setageP("");
    setsalaryP("");
    setTypeofUse("");
    setNationalidP("");
    setGuaraIDP("");
    setTaminP("");
    setfacilitiesRecP("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">قرض تمويل سيارة</h3>
      <div className="inputs-container">
        <div className="inp-container ">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              <Typography>
                حالة العميل
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  حالة العميل
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={emptype}
              onChange={(e) => setemptype(e.target.value)}
            >
              <MenuItem value={"employee"}>موظف</MenuItem>
              <MenuItem value={"pensioner"}>صاحب معاش</MenuItem>
            </Select>
          </FormControl>
        </div>
        {emptype === "employee" ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    قيمة الراتب
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                type="number"
                value={salary}
                onChange={(e) => {
                  setsalary(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography>
                    هل لديك أي قروض
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography>
                      هل لديك أي قروض
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  value={anyloans}
                  onChange={(e) => setanyloans(e.target.value)}
                >
                  <MenuItem value={"y"}>نعم</MenuItem>
                  <MenuItem value={"n"}>لا</MenuItem>
                </Select>
              </FormControl>
            </div>
            {anyloans === "y" ? (
              <>
                {inputsEmp.map((input, index) => (
                  <div className="inp-container anyloan" key={index}>
                    <TextField
                      type="number"
                      label={
                        <Typography>
                          قيمة القرض
                          <span style={{ color: "red", fontSize: "21px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      value={input}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                    <button className="add" onClick={handleAddInput}>
                      إضافة جديد
                    </button>
                    <button
                      className="remove"
                      onClick={() => handleRemoveInput(index)}
                    >
                      إزالة
                    </button>
                  </div>
                ))}
              </>
            ) : null}
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية للعميل
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setNationalid(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية للضامن
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setGuaraID(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    بيان المرتب
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setsalarystate(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    بيان حالة الموظف
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setempstate(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    إيصال المرافق
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setfacilitiesRec(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label="ملفات اخرى"
                focused
                type="file"
                inputProps={{
                  multiple: true,
                }}
                onChange={handleFileChangeOthers}
                variant="outlined"
              />
            </div>
          </>
        ) : emptype === "pensioner" ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    قيمة المعاش
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                type="number"
                value={salaryP}
                onChange={(e) => {
                  setsalaryP(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    السن
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                type="number"
                value={ageP}
                onChange={(e) => {
                  setageP(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography>
                    هل لديك أي قروض
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography>
                      هل لديك أي قروض
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  value={anyloansP}
                  onChange={(e) => setanyloansP(e.target.value)}
                >
                  <MenuItem value={"y"}>نعم</MenuItem>
                  <MenuItem value={"n"}>لا</MenuItem>
                </Select>
              </FormControl>
            </div>
            {anyloansP === "y" ? (
              <>
                {inputsP.map((input, index) => (
                  <div className="inp-container anyloan" key={index}>
                    <TextField
                      type="number"
                      label={
                        <Typography>
                          قيمة القرض
                          <span style={{ color: "red", fontSize: "21px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      value={input}
                      onChange={(event) => handleInputChangeP(index, event)}
                    />
                    <button className="add" onClick={handleAddInputP}>
                      إضافة جديد
                    </button>
                    <button
                      className="remove"
                      onClick={() => handleRemoveInputP(index)}
                    >
                      إزالة
                    </button>
                  </div>
                ))}
              </>
            ) : null}
            <div className="inp-container ">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography>
                    المستفيد
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography>
                      المستفيد
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  value={TypeofUse}
                  onChange={(e) => setTypeofUse(e.target.value)}
                >
                  <MenuItem value={"daughter"}>الأبنة</MenuItem>
                  <MenuItem value={"son"}>الأبن</MenuItem>
                  <MenuItem value={"wife"}>الزوجة</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية للعميل
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setNationalidP(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية للضامن
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setGuaraIDP(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    إيصال من التأمينات
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setTaminP(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    إيصال المرافق
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                type="file"
                onChange={(e) => {
                  setfacilitiesRecP(e.target.files[0]);
                }}
                variant="outlined"
              />
            </div>
          </>
        ) : null}

        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button
          className="buttonadd"
          onClick={
            emptype === "employee"
              ? handlesubmitEmp
              : emptype === "pensioner"
              ? handlesubmitP
              : null
          }
        >
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Banqi;
